import { format } from "date-fns";
import { memo, useEffect, useState } from "react";
import { Message } from "./message";
import styles from "./styles.module.css";

export const Body = memo(
  ({
    chatContainerRef,
    messages,
    messageTitle,
    description,
    aIAssistantText,
    meText,
    onMessageLike,
    onMessageDislike,
    checkboxLabel,
    isShowAgreeWithTerm,
    isAgreeWithTerms,
    handleTermsClick,
  }) => {
    const [time, setTime] = useState(null);

    useEffect(() => {
      setTime(format(new Date(), "h:mm aaaa"));
    }, []);

    return (
      <div
        ref={chatContainerRef}
        className={`${styles.bodyBox} ${styles.scroller}`}
      >
        <Message
          isBotMessage={true}
          headText={messageTitle}
          messageText={description}
          time={time || ""}
          aIAssistantText={aIAssistantText}
        />

        {isShowAgreeWithTerm && (
          <Message
            isTerms
            isBotMessage={true}
            messageText={description}
            time={time || ""}
            checkboxLabel={checkboxLabel}
            isAgreeWithTerms={isAgreeWithTerms}
            handleTermsClick={handleTermsClick}
          />
        )}

        {!!messages.length &&
          messages.map((message, index) => (
            <Message
              key={message.id || index}
              isBotMessage={message.isBotMessage}
              messageText={message.text}
              time={
                message.time
                  ? format(new Date(message.time), "h:mm aaaa")
                  : undefined
              }
              isLoading={message.isLoading}
              aIAssistantText={aIAssistantText}
              meText={meText}
              isReactable={message.isBotMessage && message.isReactable}
              isLiked={message.isLiked}
              onLike={() => {
                if (onMessageLike) onMessageLike(message.id);
              }}
              onDislike={() => {
                if (onMessageDislike) onMessageDislike(message.id);
              }}
            />
          ))}
      </div>
    );
  }
);
